var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_143_47540)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 9,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29 19C27.0222 19 25.0888 19.5865 23.4443 20.6853C21.7998 21.7841 20.5181 23.3459 19.7612 25.1732C19.0043 27.0004 18.8063 29.0111 19.1922 30.9509C19.578 32.8907 20.5304 34.6725 21.9289 36.0711C23.3275 37.4696 25.1093 38.422 27.0491 38.8079C28.9889 39.1937 30.9996 38.9957 32.8268 38.2388C34.6541 37.4819 36.2159 36.2002 37.3147 34.5557C38.4135 32.9112 39 30.9778 39 29C39 27.6868 38.7413 26.3864 38.2388 25.1732C37.7363 23.9599 36.9997 22.8575 36.0711 21.9289C35.1425 21.0003 34.0401 20.2638 32.8268 19.7612C31.6136 19.2587 30.3132 19 29 19ZM29 37C27.4178 37 25.871 36.5308 24.5554 35.6518C23.2398 34.7727 22.2145 33.5233 21.609 32.0615C21.0035 30.5997 20.845 28.9911 21.1537 27.4393C21.4624 25.8874 22.2243 24.462 23.3432 23.3431C24.462 22.2243 25.8874 21.4624 27.4393 21.1537C28.9911 20.845 30.5997 21.0035 32.0615 21.609C33.5233 22.2145 34.7727 23.2398 35.6518 24.5554C36.5308 25.871 37 27.4177 37 29C37 31.1217 36.1572 33.1566 34.6569 34.6569C33.1566 36.1571 31.1217 37 29 37Z",
    fill: "#F26064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 29H39C39 27.6868 38.7413 26.3864 38.2388 25.1732C37.7362 23.9599 36.9997 22.8575 36.0711 21.9289C35.1425 21.0003 34.0401 20.2638 32.8268 19.7612C31.6136 19.2587 30.3132 19 29 19V21C31.1217 21 33.1566 21.8429 34.6569 23.3431C36.1571 24.8434 37 26.8783 37 29Z",
    fill: "#F26064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_143_47540",
    x: 0.3,
    y: 0.3,
    width: 57.4,
    height: 57.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_143_47540"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_143_47540",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebIcon3);
export default __webpack_public_path__ + "static/media/webIcon3.987991ef2a5e1eb1684790106dfd192d.svg";
export { ForwardRef as ReactComponent };